import styled from "styled-components";

export const HeaderBarFiltrosContainer = styled.div`
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 66px;
  padding-right: 79px;
  background: var(--color-primary-gradient);
  box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14);
  @media (max-width: 1550px) {
    padding-left: 14px;
    padding-right: 16px;
    transition: all 0.5s;
  }
  @media (max-width: 1279px) {
    height: 60px;
    padding-left: 13px;
    padding-right: 10px;
    transition: all 0.5s;
    gap: 50px;

    ${({ $isIos }) =>
    $isIos === true
      ? `padding-top: 45px;
              height: 110px;
             `
      : `
       `};
  }
`;

export const AplicadosBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  .txtFiltros {
    width: 100%;
    text-align: center;
  }
`;

export const FiltroEtiqueta = styled.div`
  height: 32px;
  width: max-content;
  padding-left: 8px;
  padding-right: 6px;
  padding-top: 8px;
  padding-bottom: 8px;
  background: var(--color-primary);
  border-radius: 20px;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  gap: 8px;
  .cruzBox {
    position: relative;
    background-color: transparent;
    transition: background-color 0.2s ease;
    border-radius: 50%;
    padding: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .cruzBox:hover {
    background-color: rgba(
      255,
      255,
      255,
      0.5
    ); /* Fondo blanco con 50% de opacidad */
  }
`;

export const ItemBox = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
  justify-content: space-between;
`;

export const FlechaContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-right: 8px;
  rotate: -90deg;
  transform: ${(props) => props.$rotate && `rotate(180deg)`};
  transition: 0.2s ease;
`;

export const FiltroBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  .datePickerStyle {
    height: 40px;
    display: flex;
    align-items: center;
    background: var(--color-white);
    color: var(--color-latex10);
    width: 100%;
  }
  .calendarStyle {
    left: 2vh;
    top: 15vh;
  }
  .content {
    overflow: hidden;
    max-height: 0;
    opacity: 0;
    visibility: hidden; /* Evita la interacción mientras está oculto */
    transition: max-height 0.3s ease, opacity 0.3s ease, visibility 0s 0.3s; /* Retrasa 'visibility' */
  }

  .content.visible {
    overflow: auto;
    max-height: 500px; /* Ajusta según el contenido */
    opacity: 1;
    visibility: visible;
    transition: max-height 0.3s ease, opacity 0.3s ease, visibility 0s 0s; /* Visibility ocurre inmediatamente */
  }

  .content.hidden {
    max-height: 0;
    opacity: 0;
    visibility: hidden;
  }
`;

export const BtnFiltrarWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 16px 0 8px;
  margin-top: 8px;

  .btn-filtrar {
    min-width: 100px;
    height: 44px;
    border: none;
    border-radius: 8px;
    background-color: var(--color-primary);
    color: var(--color-white);
    font-size: 18px;
    font-weight: 500;
    cursor: pointer;
  }
`;

export const Line = styled.div`
  position: relative; /* Necesario para posicionar los pseudo-elementos */
  height: 1px; /* Altura de la línea */
  width: 80%;

  &::before {
    content: ""; /* Esto asegura que el pseudo-elemento se renderice */
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px; /* Grosor de la línea */
    background: linear-gradient(
      to right,
      rgba(0, 0, 0, 0),
      var(--color-grey85),
      rgba(0, 0, 0, 0)
    ); /* Gradiente difuminado */
    transform: translateY(-50%); /* Centra el pseudo-elemento verticalmente */
  }
`;
